export default {
    // 中
    zhCN: {
        region: '地区',
        vehicle_platform: '车型平台',
        code_name: '代码名称',
        abnormal_detection_time: '异常发现时间',
        return_shipment_status: '回运件状态',
        problem_status: '问题状态',
        abnormal_shutdown_time: '异常关闭时间',
        operation_code: '操作代码',
        country: '国家',
        exception_type: '异常类型',
        total_number_of_claims: '总索赔数',
        number_of_claims_after_breakpoint: '断点后索赔数',
        analyze_requirements: '分析需求',
        return_shipment_OA_time: '回运件抵达OA时间',
        function_block: '功能块',
        Supervisor: '主管人',
        abnormal_situation_description: '异常情况描述',
        known_breakpoint_information: '已知断点信息',
        overseas_information_feedback: '海外信息反馈',
        latest_progress: '最新进展(原因分析&改进断点)',
        abnormal_analysis_conclusion: '异常分析结论',
        marketing_strategy: '市场活动策略',
    },
    // 英
    enUS: {
        region: 'region',
        vehicle_platform: 'Vehicle Platform',
        code_name: 'Code Name',
        abnormal_detection_time: 'Abnormal Detection Time',
        return_shipment_status: 'Return Shipment Status',
        problem_status: 'Problem Status',
        abnormal_shutdown_time: 'Abnormal Shutdown Time',
        operation_code: 'Operation code',
        country: 'country',
        exception_type: 'Exception type',
        total_number_of_claims: 'Total number of claims',
        number_of_claims_after_breakpoint: 'Number of claims after breakpoint',
        analyze_requirements: 'Analyze requirements',
        return_shipment_OA_time: 'Return shipment arrival time at OA',
        function_block: 'Function block',
        Supervisor: 'Supervisor',
        abnormal_situation_description: 'Abnormal situation description',
        known_breakpoint_information: 'Known breakpoint information',
        overseas_information_feedback: 'Overseas information feedback',
        latest_progress: 'Latest Progress (Cause Analysis&Improvement Breakpoints)',
        abnormal_analysis_conclusion: 'Abnormal analysis conclusion',
        marketing_strategy: 'Marketing strategy',
    },
    // 德
    deDE: {
        region: 'Region',
        vehicle_platform: 'Fahrzeugplattform',
        code_name: 'Codename',
        abnormal_detection_time: 'Anomalieerkennungszeit',
        return_shipment_status: 'Rücksendestatus',
        problem_status: 'Problestatus',
        abnormal_shutdown_time: 'Anomalieabschaltzeit',
        operation_code: 'Betriebscode',
        country: 'Land',
        exception_type: 'Ausnahmetyp',
        total_number_of_claims: 'Gesamtzahl der Ansprüche',
        number_of_claims_after_breakpoint: 'Anzahl der Ansprüche nach dem Breakpoint',
        analyze_requirements: 'Analyseanforderungen',
        return_shipment_OA_time: 'Rücksendung OA Zeit',
        function_block: 'Funktionsblock',
        Supervisor: 'Aufsichtsperson',
        abnormal_situation_description: 'Beschreibung der Anomalie',
        known_breakpoint_information: 'Bekannte Breakpoint-Informationen',
        overseas_information_feedback: 'Feedback zu Überseeinformationen',
        latest_progress: 'Neueste Fortschritte (Ursachenanalyse & Verbesserungen)',
        abnormal_analysis_conclusion: 'Anomalieanalyse Schlussfolgerung',
        marketing_strategy: 'Marketingstrategie',
    },
    // 法
    frFR: {
        region: 'Région',
        vehicle_platform: 'Plateforme de véhicule',
        code_name: 'Nom de code',
        abnormal_detection_time: 'Heure de détection anormale',
        return_shipment_status: 'État de retour',
        problem_status: 'État du problème',
        abnormal_shutdown_time: 'Heure d\'arrêt anormal',
        operation_code: 'Code d\'opération',
        country: 'Pays',
        exception_type: 'Type d\'exception',
        total_number_of_claims: 'Nombre total de réclamations',
        number_of_claims_after_breakpoint: 'Nombre de réclamations après point de rupture',
        analyze_requirements: 'Exigences d\'analyse',
        return_shipment_OA_time: 'Temps de retour OA',
        function_block: 'Bloc fonctionnel',
        Supervisor: 'Superviseur',
        abnormal_situation_description: 'Description de la situation anormale',
        known_breakpoint_information: 'Informations de point de rupture connues',
        overseas_information_feedback: 'Retour d\'informations à l\'étranger',
        latest_progress: 'Derniers progrès (analyse des causes & améliorations)',
        abnormal_analysis_conclusion: 'Conclusion de l\'analyse anormale',
        marketing_strategy: 'Stratégie marketing',
    },
    // 意大利
    itIT: {
        region: 'Regione',
        vehicle_platform: 'Piattaforma del veicolo',
        code_name: 'Nome in codice',
        abnormal_detection_time: 'Tempo di rilevamento anomalo',
        return_shipment_status: 'Stato della spedizione di ritorno',
        problem_status: 'Stato del problema',
        abnormal_shutdown_time: 'Tempo di arresto anomalo',
        operation_code: 'Codice operazione',
        country: 'Paese',
        exception_type: 'Tipo di eccezione',
        total_number_of_claims: 'Numero totale di reclami',
        number_of_claims_after_breakpoint: 'Numero di reclami dopo il punto di interruzione',
        analyze_requirements: 'Requisiti di analisi',
        return_shipment_OA_time: 'Tempo di restituzione OA',
        function_block: 'Blocco funzionale',
        Supervisor: 'Supervisore',
        abnormal_situation_description: 'Descrizione della situazione anomala',
        known_breakpoint_information: 'Informazioni sul punto di interruzione conosciute',
        overseas_information_feedback: 'Feedback delle informazioni estere',
        latest_progress: 'Ultimi progressi (analisi delle cause & miglioramenti)',
        abnormal_analysis_conclusion: 'Conclusione dell\'analisi anomala',
        marketing_strategy: 'Strategia di marketing',
    },
    // 荷兰
    nlNL: {
        region: 'Regio',
        vehicle_platform: 'Voertuigplatform',
        code_name: 'Codenaam',
        abnormal_detection_time: 'Tijd van abnormale detectie',
        return_shipment_status: 'Retourverzendstatus',
        problem_status: 'Probleemstatus',
        abnormal_shutdown_time: 'Tijd van abnormale uitschakeling',
        operation_code: 'Operatiecode',
        country: 'Land',
        exception_type: 'Uitzonderingstype',
        total_number_of_claims: 'Totaal aantal claims',
        number_of_claims_after_breakpoint: 'Aantal claims na breekpunt',
        analyze_requirements: 'Analysevereisten',
        return_shipment_OA_time: 'Retourzending OA tijd',
        function_block: 'Functieblok',
        Supervisor: 'Toezichthouder',
        abnormal_situation_description: 'Beschrijving van de abnormaliteit',
        known_breakpoint_information: 'Bekende breekpuntinformatie',
        overseas_information_feedback: 'Feedback van buitenlandse informatie',
        latest_progress: 'Laatste voortgang (oorzaakanalyse & verbeteringen)',
        abnormal_analysis_conclusion: 'Conclusie van de anomalie-analyse',
        marketing_strategy: 'Marketingstrategie',
    },
    // 越南
    viVN: {
        region: 'Khu vực',
        vehicle_platform: 'Nền tảng xe',
        code_name: 'Tên mã',
        abnormal_detection_time: 'Thời gian phát hiện bất thường',
        return_shipment_status: 'Tình trạng hàng trả lại',
        problem_status: 'Tình trạng vấn đề',
        abnormal_shutdown_time: 'Thời gian tắt bất thường',
        operation_code: 'Mã hoạt động',
        country: 'Quốc gia',
        exception_type: 'Loại ngoại lệ',
        total_number_of_claims: 'Tổng số yêu cầu',
        number_of_claims_after_breakpoint: 'Số lượng yêu cầu sau điểm dừng',
        analyze_requirements: 'Yêu cầu phân tích',
        return_shipment_OA_time: 'Thời gian trả hàng OA',
        function_block: 'Khối chức năng',
        Supervisor: 'Người giám sát',
        abnormal_situation_description: 'Mô tả tình huống bất thường',
        known_breakpoint_information: 'Thông tin điểm dừng đã biết',
        overseas_information_feedback: 'Phản hồi thông tin nước ngoài',
        latest_progress: 'Tiến trình mới nhất (phân tích nguyên nhân & cải tiến)',
        abnormal_analysis_conclusion: 'Kết luận phân tích bất thường',
        marketing_strategy: 'Chiến lược tiếp thị',
    },
    // 西班牙
    esES: {
        region: 'Región',
        vehicle_platform: 'Plataforma del vehículo',
        code_name: 'Nombre en código',
        abnormal_detection_time: 'Tiempo de detección anormal',
        return_shipment_status: 'Estado del envío de devolución',
        problem_status: 'Estado del problema',
        abnormal_shutdown_time: 'Tiempo de apagado anormal',
        operation_code: 'Código de operación',
        country: 'País',
        exception_type: 'Tipo de excepción',
        total_number_of_claims: 'Número total de reclamaciones',
        number_of_claims_after_breakpoint: 'Número de reclamaciones después del punto de quiebre',
        analyze_requirements: 'Requisitos de análisis',
        return_shipment_OA_time: 'Tiempo de devolución OA',
        function_block: 'Bloque funcional',
        Supervisor: 'Supervisor',
        abnormal_situation_description: 'Descripción de la situación anormal',
        known_breakpoint_information: 'Información sobre puntos de ruptura conocidos',
        overseas_information_feedback: 'Retroalimentación de información en el extranjero',
        latest_progress: 'Últimos avances (análisis de causas & mejoras)',
        abnormal_analysis_conclusion: 'Conclusión del análisis anormal',
        marketing_strategy: 'Estrategia de marketing',
    },
    // 葡萄牙
    ptBR: {
        region: 'Região',
        vehicle_platform: 'Plataforma do veículo',
        code_name: 'Nome de código',
        abnormal_detection_time: 'Tempo de detecção anormal',
        return_shipment_status: 'Status de devolução',
        problem_status: 'Status do problema',
        abnormal_shutdown_time: 'Tempo de desligamento anormal',
        operation_code: 'Código de operação',
        country: 'País',
        exception_type: 'Tipo de exceção',
        total_number_of_claims: 'Número total de reclamações',
        number_of_claims_after_breakpoint: 'Número de reclamações após o ponto de interrupção',
        analyze_requirements: 'Requisitos de análise',
        return_shipment_OA_time: 'Tempo de devolução OA',
        function_block: 'Bloco funcional',
        Supervisor: 'Supervisor',
        abnormal_situation_description: 'Descrição da situação anormal',
        known_breakpoint_information: 'Informações sobre pontos de interrupção conhecidos',
        overseas_information_feedback: 'Feedback de informações no exterior',
        latest_progress: 'Últimos progressos (análise de causas & melhorias)',
        abnormal_analysis_conclusion: 'Conclusão da análise anormal',
        marketing_strategy: 'Estratégia de marketing',
    },
    // 波兰
    plPL: {
        region: 'Region',
        vehicle_platform: 'Platforma pojazdu',
        code_name: 'Nazwa kodowa',
        abnormal_detection_time: 'Czas wykrywania nieprawidłowości',
        return_shipment_status: 'Status zwrotu',
        problem_status: 'Status problemu',
        abnormal_shutdown_time: 'Czas anormalnego wyłączenia',
        operation_code: 'Kod operacji',
        country: 'Kraj',
        exception_type: 'Typ wyjątku',
        total_number_of_claims: 'Całkowita liczba roszczeń',
        number_of_claims_after_breakpoint: 'Liczba roszczeń po punkcie przerwania',
        analyze_requirements: 'Wymagania analizy',
        return_shipment_OA_time: 'Czas zwrotu OA',
        function_block: 'Blok funkcji',
        Supervisor: 'Nadzorca',
        abnormal_situation_description: 'Opis anomalii',
        known_breakpoint_information: 'Znane informacje o punkcie przerwania',
        overseas_information_feedback: 'Informacje zwrotne z zagranicy',
        latest_progress: 'Najnowsze postępy (analiza przyczyn & ulepszenia)',
        abnormal_analysis_conclusion: 'Wnioski z analizy anomalii',
        marketing_strategy: 'Strategia marketingowa',
    },
    // 土耳其
    trTR: {
        region: 'Bölge',
        vehicle_platform: 'Araç platformu',
        code_name: 'Kod adı',
        abnormal_detection_time: 'Anormal tespit zamanı',
        return_shipment_status: 'İade gönderim durumu',
        problem_status: 'Problem durumu',
        abnormal_shutdown_time: 'Anormal kapatma zamanı',
        operation_code: 'İşlem kodu',
        country: 'Ülke',
        exception_type: 'İstisna türü',
        total_number_of_claims: 'Toplam talep sayısı',
        number_of_claims_after_breakpoint: 'Kesme noktasından sonraki talep sayısı',
        analyze_requirements: 'Analiz gereksinimleri',
        return_shipment_OA_time: 'İade gönderim OA zamanı',
        function_block: 'Fonksiyon bloğu',
        Supervisor: 'Gözetmen',
        abnormal_situation_description: 'Anormal durum açıklaması',
        known_breakpoint_information: 'Bilinen kesme noktası bilgileri',
        overseas_information_feedback: 'Yurt dışı bilgi geri bildirimi',
        latest_progress: 'Son gelişmeler (neden analizi & iyileştirmeler)',
        abnormal_analysis_conclusion: 'Anormal analiz sonuçları',
        marketing_strategy: 'Pazarlama stratejisi',
    },
    // 捷克语
    csCZ: {
        region: 'region',
        vehicle_platform: 'Platforma vozidla',
        code_name: 'Název kódu',
        abnormal_detection_time: 'Abnormální doba detekce',
        return_shipment_status: 'Stav vrácení zásilky',
        problem_status: 'Stav problému',
        abnormal_shutdown_time: 'Neobvyklá doba vypnutí',
        operation_code: 'Kód operace',
        country: 'země',
        exception_type: 'Typ výjimky',
        total_number_of_claims: 'Celkový počet žádostí',
        number_of_claims_after_breakpoint: 'Počet nároků po bodu breakpointu',
        analyze_requirements: 'Analýza požadavků',
        return_shipment_OA_time: 'Return shipment arrival time at OA',
        function_block: 'Funkční blok',
        Supervisor: 'Vedoucí pracovník',
        abnormal_situation_description: 'Popis abnormální situace',
        known_breakpoint_information: 'Známé informace o bodu zlomu',
        overseas_information_feedback: 'Zpětná vazba informací ze zahraničí',
        latest_progress: 'Nejnovější pokrok (analýza příčin a zlomové body zlepšení)',
        abnormal_analysis_conclusion: 'Abnormální závěr analýzy',
        marketing_strategy: 'Marketingová strategie',
    },
    // 匈牙利语
    huHU: {
        region: 'Régió',
        vehicle_platform: 'Járműplatform',
        code_name: 'Kódnév',
        abnormal_detection_time: 'Rendellenes észlelés ideje',
        return_shipment_status: 'Visszaküldés állapota',
        problem_status: 'Probléma állapota',
        abnormal_shutdown_time: 'Rendellenes leállás ideje',
        operation_code: 'Műveletkód',
        country: 'Ország',
        exception_type: 'Kivétel típusa',
        total_number_of_claims: 'Összes igény száma',
        number_of_claims_after_breakpoint: 'Igények száma lerobbanás után',
        analyze_requirements: 'Elemzési követelmények',
        return_shipment_OA_time: 'Visszaküldött szállítmány érkezési ideje OA-hoz',
        function_block: 'Funkcióblokk',
        Supervisor: 'Felettes',
        abnormal_situation_description: 'Rendellenes helyzet leírása',
        known_breakpoint_information: 'Ismert lerobbanási adatok',
        overseas_information_feedback: 'Tengeren túli adatok visszajelzése',
        latest_progress: 'Legutóbbi előrelépések (lerobbanások okainak elemzése és fejlesztése)',
        abnormal_analysis_conclusion: 'Rendelleneség elemzésének eredménye',
        marketing_strategy: 'Marketingstratégia',
    },
    // 俄罗斯语
    ruRU: {
        region: 'Регион',
        vehicle_platform: 'Платформа автомобиля',
        code_name: 'Код Название',
        abnormal_detection_time: 'Время аномального обнаружения',
        return_shipment_status: 'Статус возвратной отправки',
        problem_status: 'Статус проблемы',
        abnormal_shutdown_time: 'Время аномального завершения',
        operation_code: 'Код операции',
        country: 'Страна',
        exception_type: 'Тип исключения',
        total_number_of_claims: 'Общее количество требований',
        number_of_claims_after_breakpoint: 'Количество требований после прерывания',
        analyze_requirements: 'Требования анализа',
        return_shipment_OA_time: 'Время прибытия возвратной отправки в OA',
        function_block: 'Блок функции',
        Supervisor: 'Руководитель',
        abnormal_situation_description: 'Описание аномальной ситуации',
        known_breakpoint_information: 'Известная информация о прерывании',
        overseas_information_feedback: 'Обратная связь о зарубежной информации',
        latest_progress: 'Последний прогресс (анализ причин и меры по улучшению прерываний)',
        abnormal_analysis_conclusion: 'Заключение по аномальному анализу',
        marketing_strategy: 'Маркетинговая стратегия',
    },
    // 沙特阿拉伯
    arSA: {
        region: 'المنطقة',
        vehicle_platform: 'منصة الطراز',
        code_name: 'اسم الرمز',
        abnormal_detection_time: 'وقت اكتشاف الاستثناء',
        return_shipment_status: 'حالة الشحنة المرتجعة',
        problem_status: 'حالة المشكلة',
        abnormal_shutdown_time: 'وقت إغلاق الاستثناء',
        operation_code: 'رمز العملية',
        country: 'الدولة',
        exception_type: 'نوع الاستثناء',
        total_number_of_claims: 'إجمالي عدد المطالبات',
        number_of_claims_after_breakpoint: 'عدد المطالبات بعد نقطة التوقف',
        analyze_requirements: 'متطلبات التحليل',
        return_shipment_OA_time: 'وقت وصول الشحنة المرتجعة إلى OA',
        function_block: 'وحدة الوظيفة',
        Supervisor: 'المشرف',
        abnormal_situation_description: 'وصف الحالة غير الطبيعية',
        known_breakpoint_information: 'معلومات نقطة التوقف المعروفة',
        overseas_information_feedback: 'ملاحظات المعلومات من الخارج',
        latest_progress: 'آخر التطورات (تحليل الأسباب وتحسين نقطة التوقف)',
        abnormal_analysis_conclusion: 'استنتاج تحليل الاستثناء',
        marketing_strategy: 'استراتيجية التسويق',
    },
    // 保加利亚
    bgBG: {
        region: 'Регион',
        vehicle_platform: 'Платформа на модела',
        code_name: 'Кодово име',
        abnormal_detection_time: 'Време на откриване на аномалията',
        return_shipment_status: 'Статус на върнатата пратка',
        problem_status: 'Статус на проблема',
        abnormal_shutdown_time: 'Време на затваряне на аномалията',
        operation_code: 'Код на операцията',
        country: 'Държава',
        exception_type: 'Тип на изключението',
        total_number_of_claims: 'Общ брой искания',
        number_of_claims_after_breakpoint: 'Брой искания след точката на прекъсване',
        analyze_requirements: 'Изисквания за анализ',
        return_shipment_OA_time: 'Време на пристигане на върнатата пратка в OA',
        function_block: 'Функционален блок',
        Supervisor: 'Ръководител',
        abnormal_situation_description: 'Описание на необичайната ситуация',
        known_breakpoint_information: 'Известна информация за точката на прекъсване',
        overseas_information_feedback: 'Обратна връзка от чужбина',
        latest_progress:
            'Последен напредък (анализ на причините и подобрение на точката на прекъсване)',
        abnormal_analysis_conclusion: 'Заключение от анализа на аномалията',
        marketing_strategy: 'Маркетингова стратегия',
    },
    // 丹麦语
    daDK: {
        region: 'Region',
        vehicle_platform: 'Køretøjsplatform',
        code_name: 'Kodenavn',
        abnormal_detection_time: 'Tidspunkt for opdagelse af unormalitet',
        return_shipment_status: 'Status for returforhold',
        problem_status: 'Problemstatus',
        abnormal_shutdown_time: 'Tidspunkt for lukning af unormalitet',
        operation_code: 'Handlingskode',
        country: 'Land',
        exception_type: 'Undtagelsestype',
        total_number_of_claims: 'Samlet antal reklamationer',
        number_of_claims_after_breakpoint: 'Antal reklamationer efter breakpoint',
        analyze_requirements: 'Analysekrav',
        return_shipment_OA_time: 'Tidspunkt for ankomst af returforhold til OA',
        function_block: 'Funktionsblok',
        Supervisor: 'Overvåger',
        abnormal_situation_description: 'Beskrivelse af unormal situation',
        known_breakpoint_information: 'Kendt breakpoint-information',
        overseas_information_feedback: 'Feedback fra udlandet',
        latest_progress: 'Seneste fremskridt (årsagsanalyse og forbedring af breakpoint)',
        abnormal_analysis_conclusion: 'Konklusion på unormalitetsanalyse',
        marketing_strategy: 'Markedsføringsstrategi',
    },
    // 芬兰语
    fiFI: {
        region: 'Alue',
        vehicle_platform: 'Ajoneuvoplatformi',
        code_name: 'Koodinimi',
        abnormal_detection_time: 'Poikkeaman havaitsemisaika',
        return_shipment_status: 'Palautuslähetysten tila',
        problem_status: 'Ongelman tila',
        abnormal_shutdown_time: 'Poikkeaman sulkemisaika',
        operation_code: 'Toimenpidekoodi',
        country: 'Maa',
        exception_type: 'Poikkeustyyppi',
        total_number_of_claims: 'Reklamaatioiden kokonaismäärä',
        number_of_claims_after_breakpoint: 'Reklamaatioiden määrä katkaisupisteen jälkeen',
        analyze_requirements: 'Analyysivaatimukset',
        return_shipment_OA_time: 'Palautuslähetysten saapumisaika OA:han',
        function_block: 'Toimintolohko',
        Supervisor: 'Esimies',
        abnormal_situation_description: 'Poikkeuksellisen tilanteen kuvaus',
        known_breakpoint_information: 'Tunnetut tiedot katkaisupisteestä',
        overseas_information_feedback: 'Ulkomailta saatu palaute',
        latest_progress: 'Viimeisimmät edistymiset (syyanalyysi ja katkaisupisteen parannus)',
        abnormal_analysis_conclusion: 'Poikkeaman analyysin johtopäätös',
        marketing_strategy: 'Markkinointistrategia',
    },
    // 繁体中文台湾
    zhTW: {
        region: '地區',
        vehicle_platform: '車型平台',
        code_name: '代號名稱',
        abnormal_detection_time: '異常發現時間',
        return_shipment_status: '回運件狀態',
        problem_status: '問題狀態',
        abnormal_shutdown_time: '異常關閉時間',
        operation_code: '操作代碼',
        country: '國家',
        exception_type: '異常類型',
        total_number_of_claims: '總索賠數',
        number_of_claims_after_breakpoint: '斷點後索賠數',
        analyze_requirements: '分析需求',
        return_shipment_OA_time: '回運件抵達OA時間',
        function_block: '功能模組',
        Supervisor: '主管人',
        abnormal_situation_description: '異常情況描述',
        known_breakpoint_information: '已知斷點資訊',
        overseas_information_feedback: '海外資訊回饋',
        latest_progress: '最新進展（原因分析＆改進斷點）',
        abnormal_analysis_conclusion: '異常分析結論',
        marketing_strategy: '市場活動策略',
    },
    // 克罗地亚
    hrHR: {
        region: 'Regija',
        vehicle_platform: 'Platforma vozila',
        code_name: 'Kôdno ime',
        abnormal_detection_time: 'Vrijeme otkrivanja anomalije',
        return_shipment_status: 'Status vraćene pošiljke',
        problem_status: 'Status problema',
        abnormal_shutdown_time: 'Vrijeme zatvaranja anomalije',
        operation_code: 'Kôd operacije',
        country: 'Država',
        exception_type: 'Vrsta iznimke',
        total_number_of_claims: 'Ukupan broj reklamacija',
        number_of_claims_after_breakpoint: 'Broj reklamacija nakon točke prekida',
        analyze_requirements: 'Zahtjevi za analizu',
        return_shipment_OA_time: 'Vrijeme dolaska vraćene pošiljke u OA',
        function_block: 'Funkcijski blok',
        Supervisor: 'Nadglednik',
        abnormal_situation_description: 'Opis nenormalne situacije',
        known_breakpoint_information: 'Poznate informacije o točki prekida',
        overseas_information_feedback: 'Povratne informacije iz inozemstva',
        latest_progress: 'Najnoviji napredak (analiza uzroka i poboljšanje točke prekida)',
        abnormal_analysis_conclusion: 'Zaključak analize anomalije',
        marketing_strategy: 'Marketinška strategija',
    },
    // 拉脱维亚
    lvLV: {
        region: 'Reģions',
        vehicle_platform: 'Transportlīdzekļa platforma',
        code_name: 'Koda nosaukums',
        abnormal_detection_time: 'Anomālijas atklāšanas laiks',
        return_shipment_status: 'Atgrieztās sūtījuma statuss',
        problem_status: 'Problēmas statuss',
        abnormal_shutdown_time: 'Anomālijas slēgšanas laiks',
        operation_code: 'Darbības kods',
        country: 'Valsts',
        exception_type: 'Izņēmuma veids',
        total_number_of_claims: 'Kopējais prasību skaits',
        number_of_claims_after_breakpoint: 'Prasību skaits pēc lūzuma punkta',
        analyze_requirements: 'Analīzes prasības',
        return_shipment_OA_time: 'Atgrieztās sūtījuma ierašanās laiks OA',
        function_block: 'Funkcionālais bloks',
        Supervisor: 'Uzraugs',
        abnormal_situation_description: 'Anomālas situācijas apraksts',
        known_breakpoint_information: 'Zināma informācija par lūzuma punktu',
        overseas_information_feedback: 'Ārzemju informācijas atsauksme',
        latest_progress: 'Jaunākie panākumi (cēloņu analīze un lūzuma punkta uzlabošana)',
        abnormal_analysis_conclusion: 'Anomālijas analīzes secinājums',
        marketing_strategy: 'Mārketinga stratēģija',
    },
    // 立陶宛
    ltLT: {
        region: 'Regionas',
        vehicle_platform: 'Transporto priemonės platforma',
        code_name: 'Kodo pavadinimas',
        abnormal_detection_time: 'Anomalijos aptikimo laikas',
        return_shipment_status: 'Grąžintos siuntos būsena',
        problem_status: 'Problemos būsena',
        abnormal_shutdown_time: 'Anomalijos uždarymo laikas',
        operation_code: 'Operacijos kodas',
        country: 'Šalis',
        exception_type: 'Išimties tipas',
        total_number_of_claims: 'Visų pretenzijų skaičius',
        number_of_claims_after_breakpoint: 'Pretenzijų skaičius po lūžio taško',
        analyze_requirements: 'Analizės reikalavimai',
        return_shipment_OA_time: 'Grąžintos siuntos atvykimo į OA laikas',
        function_block: 'Funkcinis blokas',
        Supervisor: 'Vadovas',
        abnormal_situation_description: 'Anomalinės situacijos aprašymas',
        known_breakpoint_information: 'Žinoma informacija apie lūžio tašką',
        overseas_information_feedback: 'Užsienio informacijos atsiliepimai',
        latest_progress: 'Naujausi pasiekimai (priežasčių analizė ir lūžio taško patobulinimas)',
        abnormal_analysis_conclusion: 'Anomalijos analizės išvada',
        marketing_strategy: 'Rinkodaros strategija',
    },
    // 罗马尼亚
    roRO: {
        region: 'Regiune',
        vehicle_platform: 'Platformă vehicul',
        code_name: 'Nume cod',
        abnormal_detection_time: 'Timp detectare anomalie',
        return_shipment_status: 'Stare expediție returnată',
        problem_status: 'Stare problemă',
        abnormal_shutdown_time: 'Timp închidere anomalie',
        operation_code: 'Cod operațiune',
        country: 'Țară',
        exception_type: 'Tip excepție',
        total_number_of_claims: 'Număr total de reclamații',
        number_of_claims_after_breakpoint: 'Număr de reclamații după punctul de întrerupere',
        analyze_requirements: 'Cerințe de analiză',
        return_shipment_OA_time: 'Timp sosire expediție returnată la OA',
        function_block: 'Bloc funcțional',
        Supervisor: 'Supervizor',
        abnormal_situation_description: 'Descriere situație anormală',
        known_breakpoint_information: 'Informații cunoscute despre punctul de întrerupere',
        overseas_information_feedback: 'Feedback informații din străinătate',
        latest_progress:
            'Cele mai recente progrese (analiză cauză și îmbunătățire punct întrerupere)',
        abnormal_analysis_conclusion: 'Concluzie analiză anomalie',
        marketing_strategy: 'Strategie de marketing',
    },
    // 挪威博克马尔
    nbNO: {
        region: 'Region',
        vehicle_platform: 'Kjøretøyplattform',
        code_name: 'Kodenavn',
        abnormal_detection_time: 'Tidspunkt for oppdagelse av unormalitet',
        return_shipment_status: 'Status for returfrakt',
        problem_status: 'Problemstatus',
        abnormal_shutdown_time: 'Tidspunkt for lukking av unormalitet',
        operation_code: 'Operasjonskode',
        country: 'Land',
        exception_type: 'Unntakstype',
        total_number_of_claims: 'Totalt antall krav',
        number_of_claims_after_breakpoint: 'Antall krav etter brytningspunkt',
        analyze_requirements: 'Analysekrav',
        return_shipment_OA_time: 'Tidspunkt for ankomst av returfrakt til OA',
        function_block: 'Funksjonsblokk',
        Supervisor: 'Overvåker',
        abnormal_situation_description: 'Beskrivelse av unormal situasjon',
        known_breakpoint_information: 'Kjent informasjon om brytningspunkt',
        overseas_information_feedback: 'Tilbakemelding fra utlandet',
        latest_progress: 'Siste fremgang (årsaksanalyse og forbedring av brytningspunkt)',
        abnormal_analysis_conclusion: 'Konklusjon fra unormalitetsanalyse',
        marketing_strategy: 'Markedsføringsstrategi',
    },
    // 葡萄牙语巴西
    ptBX: {
        region: 'Região',
        vehicle_platform: 'Plataforma do modelo',
        code_name: 'Nome de código',
        abnormal_detection_time: 'Horário da detecção da anomalia',
        return_shipment_status: 'Status da remessa devolvida',
        problem_status: 'Status do problema',
        abnormal_shutdown_time: 'Horário do encerramento da anomalia',
        operation_code: 'Código de operação',
        country: 'País',
        exception_type: 'Tipo de exceção',
        total_number_of_claims: 'Número total de reclamações',
        number_of_claims_after_breakpoint: 'Número de reclamações após o ponto de ruptura',
        analyze_requirements: 'Requisitos de análise',
        return_shipment_OA_time: 'Horário de chegada da remessa devolvida ao OA',
        function_block: 'Bloco funcional',
        Supervisor: 'Supervisor',
        abnormal_situation_description: 'Descrição da situação anômala',
        known_breakpoint_information: 'Informações conhecidas sobre o ponto de ruptura',
        overseas_information_feedback: 'Feedback de informações internacionais',
        latest_progress: 'Últimos avanços (análise de causas e melhoria do ponto de ruptura)',
        abnormal_analysis_conclusion: 'Conclusão da análise da anomalia',
        marketing_strategy: 'Estratégia de marketing',
    },
    // 瑞典语
    svSE: {
        region: 'Region',
        vehicle_platform: 'Fordonsplattform',
        code_name: 'Kodnamn',
        abnormal_detection_time: 'Tidpunkt för upptäckt av avvikelse',
        return_shipment_status: 'Status för returförsändelse',
        problem_status: 'Problemstatus',
        abnormal_shutdown_time: 'Tidpunkt för stängning av avvikelse',
        operation_code: 'Åtgärds­kod',
        country: 'Land',
        exception_type: 'Undantagstyp',
        total_number_of_claims: 'Totalt antal reklamationer',
        number_of_claims_after_breakpoint: 'Antal reklamationer efter brytpunkt',
        analyze_requirements: 'Analyskrav',
        return_shipment_OA_time: 'Tidpunkt för ankomst av returförsändelse till OA',
        function_block: 'Funktionsblock',
        Supervisor: 'Ansvarig',
        abnormal_situation_description: 'Beskrivning av avvikande situation',
        known_breakpoint_information: 'Känd information om brytpunkt',
        overseas_information_feedback: 'Återkoppling från utlandet',
        latest_progress: 'Senaste framsteg (orsaksanalys och förbättring av brytpunkt)',
        abnormal_analysis_conclusion: 'Slutsats från avvikelseanalys',
        marketing_strategy: 'Marknadsföringsstrategi',
    },
    // 斯洛伐克
    skSK: {
        region: 'Región',
        vehicle_platform: 'Platforma vozidla',
        code_name: 'Kódové meno',
        abnormal_detection_time: 'Čas zistenia abnormality',
        return_shipment_status: 'Stav vrátenej zásielky',
        problem_status: 'Stav problému',
        abnormal_shutdown_time: 'Čas ukončenia abnormality',
        operation_code: 'Kód operácie',
        country: 'Krajina',
        exception_type: 'Typ výnimky',
        total_number_of_claims: 'Celkový počet nárokov',
        number_of_claims_after_breakpoint: 'Počet nárokov po bode prerušenia',
        analyze_requirements: 'Požiadavky na analýzu',
        return_shipment_OA_time: 'Čas príchodu vrátenej zásielky do OA',
        function_block: 'Funkčný blok',
        Supervisor: 'Dohliadateľ',
        abnormal_situation_description: 'Popis abnormálnej situácie',
        known_breakpoint_information: 'Známe informácie o bode prerušenia',
        overseas_information_feedback: 'Spätná väzba zo zahraničia',
        latest_progress: 'Najnovší pokrok (analýza príčin a vylepšenie bodu prerušenia)',
        abnormal_analysis_conclusion: 'Záver analýzy abnormality',
        marketing_strategy: 'Marketingová stratégia',
    },
    // 斯洛文尼亚
    slSI: {
        region: 'Regija',
        vehicle_platform: 'Platforma vozila',
        code_name: 'Kodno ime',
        abnormal_detection_time: 'Čas odkrivanja nepravilnosti',
        return_shipment_status: 'Stanje vračilne pošiljke',
        problem_status: 'Stanje težave',
        abnormal_shutdown_time: 'Čas zaprtja nepravilnosti',
        operation_code: 'Koda operacije',
        country: 'Država',
        exception_type: 'Vrsta izjeme',
        total_number_of_claims: 'Skupno število zahtevkov',
        number_of_claims_after_breakpoint: 'Število zahtevkov po prelomni točki',
        analyze_requirements: 'Zahteve za analizo',
        return_shipment_OA_time: 'Čas prihoda vračilne pošiljke v OA',
        function_block: 'Funkcijski blok',
        Supervisor: 'Nadzornik',
        abnormal_situation_description: 'Opis nenavadne situacije',
        known_breakpoint_information: 'Znane informacije o prelomni točki',
        overseas_information_feedback: 'Povratne informacije iz tujine',
        latest_progress: 'Najnovejši napredek (analiza vzrokov in izboljšava prelomne točke)',
        abnormal_analysis_conclusion: 'Zaključek analize nepravilnosti',
        marketing_strategy: 'Tržna strategija',
    },
    // 泰语
    thTH: {
        region: 'ภูมิภาค',
        vehicle_platform: 'แพลตฟอร์มยานพาหนะ',
        code_name: 'ชื่อรหัส',
        abnormal_detection_time: 'เวลาตรวจพบความผิดปกติ',
        return_shipment_status: 'สถานะสินค้าที่ส่งคืน',
        problem_status: 'สถานะปัญหา',
        abnormal_shutdown_time: 'เวลาปิดกรณีความผิดปกติ',
        operation_code: 'รหัสการดำเนินการ',
        country: 'ประเทศ',
        exception_type: 'ประเภทข้อยกเว้น',
        total_number_of_claims: 'จำนวนการเรียกร้องทั้งหมด',
        number_of_claims_after_breakpoint: 'จำนวนการเรียกร้องหลังจุดหยุด',
        analyze_requirements: 'ข้อกำหนดการวิเคราะห์',
        return_shipment_OA_time: 'เวลาที่สินค้าที่ส่งคืนมาถึง OA',
        function_block: 'บล็อกฟังก์ชัน',
        Supervisor: 'หัวหน้างาน',
        abnormal_situation_description: 'คำอธิบายสถานการณ์ผิดปกติ',
        known_breakpoint_information: 'ข้อมูลจุดหยุดที่ทราบแล้ว',
        overseas_information_feedback: 'ข้อเสนอแนะจากต่างประเทศ',
        latest_progress: 'ความคืบหน้าล่าสุด (วิเคราะห์สาเหตุและปรับปรุงจุดหยุด)',
        abnormal_analysis_conclusion: 'สรุปผลการวิเคราะห์ความผิดปกติ',
        marketing_strategy: 'กลยุทธ์ทางการตลาด',
    },
    // 乌克兰语
    ukUA: {
        region: 'Регіон',
        vehicle_platform: 'Платформа автомобіля',
        code_name: 'Кодова назва',
        abnormal_detection_time: 'Час виявлення аномалії',
        return_shipment_status: 'Статус повернутої партії',
        problem_status: 'Статус проблеми',
        abnormal_shutdown_time: 'Час закриття аномалії',
        operation_code: 'Код операції',
        country: 'Країна',
        exception_type: 'Тип винятку',
        total_number_of_claims: 'Загальна кількість претензій',
        number_of_claims_after_breakpoint: 'Кількість претензій після точки розриву',
        analyze_requirements: 'Вимоги до аналізу',
        return_shipment_OA_time: 'Час прибуття повернутої партії до ОА',
        function_block: 'Функціональний блок',
        Supervisor: 'Керівник',
        abnormal_situation_description: 'Опис аномальної ситуації',
        known_breakpoint_information: 'Відома інформація про точку розриву',
        overseas_information_feedback: 'Зворотний зв’язок з-за кордону',
        latest_progress: 'Останній прогрес (аналіз причин та покращення точки розриву)',
        abnormal_analysis_conclusion: 'Висновок щодо аналізу аномалії',
        marketing_strategy: 'Маркетингова стратегія',
    },
    // 希腊语
    elGR: {
        region: 'Περιοχή',
        vehicle_platform: 'Πλατφόρμα οχήματος',
        code_name: 'Κωδική ονομασία',
        abnormal_detection_time: 'Ώρα ανίχνευσης ανωμαλίας',
        return_shipment_status: 'Κατάσταση επιστρεφόμενης αποστολής',
        problem_status: 'Κατάσταση προβλήματος',
        abnormal_shutdown_time: 'Ώρα κλεισίματος ανωμαλίας',
        operation_code: 'Κωδικός λειτουργίας',
        country: 'Χώρα',
        exception_type: 'Τύπος εξαίρεσης',
        total_number_of_claims: 'Συνολικός αριθμός αξιώσεων',
        number_of_claims_after_breakpoint: 'Αριθμός αξιώσεων μετά το σημείο διακοπής',
        analyze_requirements: 'Απαιτήσεις ανάλυσης',
        return_shipment_OA_time: 'Ώρα άφιξης επιστρεφόμενης αποστολής στο OA',
        function_block: 'Λειτουργικό τμήμα',
        Supervisor: 'Επόπτης',
        abnormal_situation_description: 'Περιγραφή ανώμαλης κατάστασης',
        known_breakpoint_information: 'Γνωστές πληροφορίες για το σημείο διακοπής',
        overseas_information_feedback: 'Σχόλια από το εξωτερικό',
        latest_progress: 'Τελευταία πρόοδος (ανάλυση αιτιών & βελτίωση σημείου διακοπής)',
        abnormal_analysis_conclusion: 'Συμπέρασμα ανάλυσης ανωμαλίας',
        marketing_strategy: 'Στρατηγική μάρκετινγκ',
    },
    // 爱沙尼亚
    etEE: {
        region: 'Piirkond',
        vehicle_platform: 'Sõiduki platvorm',
        code_name: 'Koodnimi',
        abnormal_detection_time: 'Anomaalia tuvastamise aeg',
        return_shipment_status: 'Tagastatud saatmise olek',
        problem_status: 'Probleemi olek',
        abnormal_shutdown_time: 'Anomaalia sulgemise aeg',
        operation_code: 'Tegevuse kood',
        country: 'Riik',
        exception_type: 'Erandid tüüp',
        total_number_of_claims: 'Kokku nõudeid',
        number_of_claims_after_breakpoint: 'Nõudeid pärast murdepunkti',
        analyze_requirements: 'Analüüsinõuded',
        return_shipment_OA_time: 'Tagastatud saatmise saabumisaeg OA-sse',
        function_block: 'Funktsionaalne plokk',
        Supervisor: 'Juhataja',
        abnormal_situation_description: 'Anomaalse olukorra kirjeldus',
        known_breakpoint_information: 'Tuntud murdepunkti info',
        overseas_information_feedback: 'Tagasiside välismaalt',
        latest_progress: 'Viimased edusammud (põhjuse analüüs ja murdepunkti täiustamine)',
        abnormal_analysis_conclusion: 'Anomaalia analüüsi järeldus',
        marketing_strategy: 'Turundusstrateegia',
    },
    // 哈萨克
    kkKZ: {
        region: 'Аймақ',
        vehicle_platform: 'Көлік платформасы',
        code_name: 'Кодтық атауы',
        abnormal_detection_time: 'Аномалияны анықтау уақыты',
        return_shipment_status: 'Қайтарылған жүктің күйі',
        problem_status: 'Мәселенің күйі',
        abnormal_shutdown_time: 'Аномалияны жабу уақыты',
        operation_code: 'Әрекет коды',
        country: 'Ел',
        exception_type: 'Ерекшелік түрі',
        total_number_of_claims: 'Талаптардың жалпы саны',
        number_of_claims_after_breakpoint: 'Үзіліс нүктесінен кейінгі талаптар саны',
        analyze_requirements: 'Талдау талаптары',
        return_shipment_OA_time: 'Қайтарылған жүктің OA-ға келу уақыты',
        function_block: 'Функционалды блок',
        Supervisor: 'Басшы',
        abnormal_situation_description: 'Аномалдық жағдайдың сипаттамасы',
        known_breakpoint_information: 'Үзіліс нүктесі туралы белгілі ақпарат',
        overseas_information_feedback: 'Шетелден кері байланыс',
        latest_progress: 'Соңғы жаңалықтар (себептерді талдау және үзіліс нүктесін жақсарту)',
        abnormal_analysis_conclusion: 'Аномалияны талдау қорытындысы',
        marketing_strategy: 'Маркетинг стратегиясы',
    },
    // 希伯来语
    heIL: {
        region: 'אזור',
        vehicle_platform: 'פלטפורמת דגם הרכב',
        code_name: 'שם קוד',
        abnormal_detection_time: 'זמן גילוי חריגה',
        return_shipment_status: 'סטטוס משלוח מוחזר',
        problem_status: 'סטטוס בעיה',
        abnormal_shutdown_time: 'זמן סגירת חריגה',
        operation_code: 'קוד פעולה',
        country: 'מדינה',
        exception_type: 'סוג חריגה',
        total_number_of_claims: 'מספר תביעות כולל',
        number_of_claims_after_breakpoint: 'מספר תביעות לאחר נקודת השבירה',
        analyze_requirements: 'דרישות ניתוח',
        return_shipment_OA_time: 'זמן הגעת המשלוח המוחזר ל-OA',
        function_block: 'בלוק פונקציונלי',
        Supervisor: 'אחראי',
        abnormal_situation_description: 'תיאור מצב חריג',
        known_breakpoint_information: 'מידע ידוע על נקודת השבירה',
        overseas_information_feedback: 'משוב מידע מחו"ל',
        latest_progress: 'התקדמות אחרונה (ניתוח סיבות ושיפור נקודת השבירה)',
        abnormal_analysis_conclusion: 'מסקנות ניתוח חריגה',
        marketing_strategy: 'אסטרטגיית שיווק',
    },
};
